var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLand({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.59 15.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #8b8c9e;\n        stroke-linejoin: round;\n        stroke-width: .93px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "30.13 14.72 .47 14.72 9.78 7.5 20.81 7.5 30.13 14.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "6.13 10.51 14.63 10.51 14.63 7.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.69,
    y1: 10.51,
    x2: 14.36,
    y2: 10.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.04,14.72c-.29,.29-.51-4.01-.51-4.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.89,2.89c0,1.34-2.42,5.52-2.42,5.52,0,0-2.42-4.18-2.42-5.52s1.09-2.42,2.42-2.42,2.42,1.09,2.42,2.42Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18.46,
    cy: 2.98,
    r: 0.98
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLand);
export default __webpack_public_path__ + "static/media/land.70e918ab.svg";
export { ForwardRef as ReactComponent };